<div class="bg_login d-flex">
    <div class="w-50 h-100 login_div">
        <div class="login_form">
            <h3 class="sign_in d-flex justify-content-between">{{'INFO.SIGN_IN' | translate}} <app-change-language [ShowFullName]="false"></app-change-language> </h3>
            <div class="login_field">
                <label class="lbl_pos_field">{{'LOGIN.EMAIL'|translate}}
                    <i *ngIf="errorModel!=null && errorModel['Username']!=null"
                        class="pi pi-exclamation-circle float-end me-1 error_color pt-1"
                        pTooltip="{{errorModel['Username']|translate}}" tooltipPosition="top"></i>
                </label>
                <input type="text" class="input_pos_field" [(ngModel)]="loginModel.username">
                <label class="lbl_pos_field">{{'LOGIN.PASSWORD'|translate}}
                    <i *ngIf="errorModel!=null && errorModel['Password']!=null"
                    class="pi pi-exclamation-circle float-end me-1 error_color pt-1"
                    pTooltip="{{errorModel['Password']|translate}}" tooltipPosition="top"></i>
                </label>
                <input type="password" class="input_pos_field" [(ngModel)]="loginModel.password">
                <div class="page-links">
                  <!-- <a type="button" routerLink="/signup" class="signup_link">{{'INFO.SIGN_UP' | translate }}</a> -->
                  <a type="button" routerLink="/forgot-password" class="right signup_link">{{'INFO.FORGOT_PASSWORD'|translate}}?</a>
                </div>
                <button class="btn_login" (click)="login(loginModel)">{{'INFO.SIGN_IN'|translate}}</button>
            </div>
        </div>
    </div>
    <div class="w-50 h-100 logo_div ">
        <div class="logo me-2"></div>
    </div>
</div>
